import { HttpRequest, HttpEvent, HttpHandlerFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export function csrfInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  function getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  // Only attach CSRF to our API — custom headers on third-party requests
  // (e.g. api.github.com) trigger CORS preflight failures.
  if (!req.url.startsWith(environment.apiURL)) {
    return next(req);
  }

  const csrfToken = getCookie('csrftoken');
  if (csrfToken) {
    const cloned = req.clone({
      headers: req.headers.set('X-CSRFToken', csrfToken),
    });
    return next(cloned);
  }
  return next(req);
}
